import { FormikErrors } from 'formik';
import {
  LegalEntityOurDataDto,
  LegalEntityOurDataCreateDto,
  LegalEntityOurDataUpdateDto,
  DownloadFileDto
} from '@sr/dto';
import { FormTools } from 'utils/form-tools';

export type LegalEntityOurDataFormikFormData = {
  isClientInvoicesEnabled: boolean;
  isSupplierInvoicesEnabled: boolean;
  invoicePrefix: string,
  legalEntityTax: number,
  stamp: DownloadFileDto[],
  stampWithoutSeal: DownloadFileDto[],
  sellerSignerId: number | null
}

const toCreateDto = (formData:LegalEntityOurDataFormikFormData): LegalEntityOurDataCreateDto => ({
  isClientInvoicesEnabled: formData.isClientInvoicesEnabled,
  isSupplierInvoicesEnabled: formData.isSupplierInvoicesEnabled,
  invoicePrefix: formData.invoicePrefix,
  legalEntityTax: Number(formData.legalEntityTax),
  sellerSignerId: formData.sellerSignerId || null
});

export const formTools: FormTools<LegalEntityOurDataDto, LegalEntityOurDataCreateDto, LegalEntityOurDataUpdateDto, LegalEntityOurDataFormikFormData> = {
  fromDto: (dto: LegalEntityOurDataDto): LegalEntityOurDataFormikFormData => ({
    isClientInvoicesEnabled: dto.isClientInvoicesEnabled,
    isSupplierInvoicesEnabled: dto.isSupplierInvoicesEnabled,
    invoicePrefix: dto.invoicePrefix,
    legalEntityTax: dto.legalEntityTax,
    stamp: dto.stamp ? [dto.stamp] : [] ,
    stampWithoutSeal: dto.stampWithoutSeal ? [dto.stampWithoutSeal] : [] ,
    sellerSignerId: dto.sellerSignerId
  }),
  toCreateDto,
  toUpdateDto: (id, formData) => ({
    ...toCreateDto(formData),
    stamp: formData.stamp.length ? formData.stamp[0] : null,
    stampWithoutSeal: formData.stampWithoutSeal.length ? formData.stampWithoutSeal[0] : null,
    id
  }),
  validate: (values):FormikErrors<LegalEntityOurDataFormikFormData>=>{
    let validationResult: FormikErrors<LegalEntityOurDataFormikFormData> = {};
    if (values.invoicePrefix.length > 8) {
      validationResult.invoicePrefix = 'Максимум 8 символов';
    }
    if (values.invoicePrefix.length < 1) {
      validationResult.invoicePrefix = 'Префикс не может быть пустым';
    }
    const tax = Number(values.legalEntityTax);
    if (isNaN(tax) || tax < 0 || tax > 100) validationResult.legalEntityTax = 'Значение налога должно быть числом от 0 до 100';
    return validationResult;
  },
  emptyValues: (): LegalEntityOurDataFormikFormData => ({
    isClientInvoicesEnabled: true,
    isSupplierInvoicesEnabled: true,
    invoicePrefix: '',
    legalEntityTax: 0,
    stamp: [],
    stampWithoutSeal: [],
    sellerSignerId: null
  })
};
